import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './CaseStudy.css';

/**
 * Legacy /case-study/:id/quizzes route — quizzes now live in the case player
 * (Decision → Quizzes → Writing Task). Keep this path as a deep-link shim.
 */
const CaseQuizPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/case-study/${id}?focus=quiz`, { replace: true });
  }, [id, navigate]);

  return (
    <div className="case-study-page">
      <div className="case-study-loading">Opening case quizzes…</div>
    </div>
  );
};

export default CaseQuizPage;
